import { getSubdirectory } from "./GetSubdirectory";

export const getLocalAppData = () => {


    try {
        const subdirectory = getSubdirectory();
        const localAppData = localStorage.getItem(`${subdirectory}-appData`);

        if (!localAppData) {
            return {}
        }
        const { appid, favicon, appScope, appName,state, privacyURL, termsURL, SSO_URL, personaCode } = JSON.parse(localAppData) || {};
        return { appid, favicon, appScope, appName,state, privacyURL, termsURL, SSO_URL,personaCode };


    } catch (error) {
        console.error("Failed to parse appData from localStorage:", error);
        return {};


    }
}